import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  TranslateLoader,
  environmentGuard,
  identifierGuard,
  licenseGuard,
  loginGuard,
  publicSharedBuildingLoginGuard,
  redirectToGoToApp,
  userGuard
} from '@cfp/core';
import { BuildingReport } from './building-report';
import { PortfolioReportPrintPage } from './portfolio-report';
import { PublicBuildingReport } from './public-building-report';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'public/buildings/:publicSharedId',
        component: PublicBuildingReport,
        canActivate: [publicSharedBuildingLoginGuard]
      },
      {
        path: ':portfolioId',
        loadComponent: () => import('@cfp/shared/portfolio/layout').then((m) => m.PortfolioLayoutProvider),
        children: [
          {
            path: '',
            component: PortfolioReportPrintPage,
            data: { license: 'portfolio_report', module: 'roadmap' },
            canActivate: [loginGuard, userGuard, licenseGuard, environmentGuard, identifierGuard],
            resolve: [TranslateLoader]
          },
          {
            path: 'buildings',
            loadComponent: () =>
              import(
                /* webpackChunkName: "portfolio-buildings-roadmap-report" */
                '@cfp/features-shared/portfolio-buildings-roadmap-report'
              ).then((c) => c.PortfolioBuidingsRoadmapReport),
            data: {
              license: 'portfolio_buildings_roadmap_report',
              module: ['portfolio-buildings-roadmap-report', 'roadmap']
            },
            canActivate: [loginGuard, userGuard, licenseGuard, identifierGuard],
            resolve: [TranslateLoader]
          },
          {
            path: 'retll',
            loadComponent: () =>
              import(
                /* webpackChunkName: "lbg-portfolio-roadmap-report" */
                '@cfp/features/lbg-shared/lbg-portfolio-roadmap-report'
              ).then((c) => c.LbgPortfolioRoadmapReport),
            data: {
              license: 'portfolio_buildings_roadmap_report',
              module: ['lbg-portfolio-roadmap-report', 'portfolio-buildings-roadmap-report', 'roadmap']
            },
            canActivate: [loginGuard, userGuard, licenseGuard, identifierGuard],
            resolve: [TranslateLoader]
          }
        ]
      },
      {
        path: ':portfolioId/buildings/:buildingId',
        loadComponent: () => import('@cfp/shared/building/layout').then((m) => m.BuildingLayoutProvider),
        children: [
          {
            path: '',
            component: BuildingReport,
            data: {
              license: ['building_report', 'building_report_old'],
              appendPageTitle: 'report.title',
              hideBuildingDetailsHeader: true
            },
            canActivate: [loginGuard, userGuard, licenseGuard, environmentGuard, identifierGuard]
          }
        ]
      },
      {
        path: 'building/:portfolioId/buildings/:buildingId',
        loadComponent: () => import('@cfp/shared/building/layout').then((m) => m.BuildingLayoutProvider),
        children: [
          {
            path: '',
            component: BuildingReport,
            data: {
              license: 'building_report',
              appendPageTitle: 'report.title',
              modulePath: 'report/building',
              hideBuildingDetailsHeader: true
            },
            canActivate: [loginGuard, userGuard, licenseGuard, environmentGuard, identifierGuard]
          }
        ]
      },
      {
        path: '**',
        redirectTo: redirectToGoToApp
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportRoutingModule {}
